'use client';
import { handleHeaderColorScheme } from '@lib/store/slices/ComponentsSlice';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import useScroll from '../hooks/useScroll';

const ScrollHelperTrans = () => {
  const dispatch = useDispatch();

  const { scrollY } = useScroll();

  useEffect(() => {
    dispatch(handleHeaderColorScheme('whiteOnTransparent'));

    return function () {
      dispatch(handleHeaderColorScheme(''));
    };
  }, []);

  useEffect(() => {
    if (scrollY < 50) {
      dispatch(handleHeaderColorScheme('whiteOnTransparent'));
    } else {
      dispatch(handleHeaderColorScheme(''));
    }
  }, [scrollY]);

  return null;
};

export default ScrollHelperTrans;
